var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2WizSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1147_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 65C55.2254 65 70 50.4493 70 32.5C70 14.5507 55.2254 0 37 0C18.7746 0 4 14.5507 4 32.5C4 50.4493 18.7746 65 37 65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32.5C67 48.7494 53.6119 62 37 62C20.3881 62 7 48.7494 7 32.5C7 16.2506 20.3881 3 37 3C53.6119 3 67 16.2506 67 32.5Z",
    stroke: "url(#paint0_linear_1147_1292)",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5432 46.7432C19.5227 46.9961 19.5021 47.249 19.4758 47.5009V47.8931C19.626 48.4466 19.9391 48.8419 20.5036 49H20.8989C21.5971 48.7201 21.8429 48.1943 21.8477 47.4551C21.8619 45.1156 22.4011 42.8828 23.523 40.8335C26.2326 35.9047 30.3684 33.2165 36.0365 32.9793C37.2594 32.9349 38.4652 32.6778 39.5999 32.2195C45.4269 29.8405 48.0629 22.901 45.3146 17.1713C43.0827 12.5191 38.1775 10.1298 33.2479 11.2905C28.8053 12.3373 25.3051 16.5482 25.0893 21.1861C24.8829 25.6121 26.6342 29.0641 30.3644 31.4881C30.4163 31.5278 30.4657 31.5706 30.5123 31.6162L30.3805 31.6717C30.3001 31.7055 30.2284 31.7356 30.1573 31.7665C24.2259 34.355 20.7859 38.8814 19.713 45.2334C19.6255 45.7315 19.5844 46.2373 19.5432 46.7432ZM35.1127 13.4064C35.3179 13.3815 35.5229 13.3565 35.7266 13.3264C39.6655 13.392 42.9886 16.1529 43.8828 20.1512C44.7841 24.1842 42.6146 28.4126 38.8409 29.9757C34.539 31.7578 29.6576 29.5843 27.9467 25.1259C26.0879 20.2816 28.8338 14.8571 33.7863 13.6229C34.2197 13.5151 34.6664 13.4607 35.1127 13.4064L35.1127 13.4064ZM48.1372 40.5224C47.3974 40.5229 46.6577 40.5235 45.9179 40.5235L42.5656 40.525C42.2433 40.525 41.9211 40.5243 41.5988 40.5237C40.7786 40.5219 39.9584 40.5201 39.1382 40.5298C38.44 40.5401 37.9324 41.0619 37.9395 41.726C37.9459 42.3704 38.4463 42.8764 39.1184 42.912C39.2063 42.9146 39.2939 42.9137 39.3816 42.9129H39.3817H39.3818L39.4383 42.9123C39.4634 42.9121 39.4885 42.912 39.5137 42.912H51.9267C51.958 42.912 51.9893 42.9121 52.0206 42.9123C52.0596 42.9126 52.0986 42.913 52.1376 42.9134H52.1377C52.3169 42.9151 52.4964 42.9169 52.6747 42.9072C53.2495 42.8756 53.6819 42.5103 53.7966 41.9743C53.9666 41.1836 53.4258 40.5235 52.5758 40.5235C51.0963 40.5203 49.6167 40.5213 48.1372 40.5224ZM45.9187 35.6468C46.6585 35.6468 47.3982 35.6464 48.138 35.6459C49.6175 35.6451 51.0971 35.6442 52.5766 35.6468C53.4242 35.6468 53.9674 36.307 53.7966 37.0968C53.7446 37.3427 53.6151 37.5655 53.4271 37.7323C53.2391 37.8991 53.0025 38.0012 52.7522 38.0235C52.6814 38.0296 52.6097 38.0291 52.5382 38.0285H52.5382C52.5178 38.0284 52.4974 38.0282 52.477 38.0282H39.3184C39.1742 38.0341 39.0298 38.0249 38.8875 38.0005C38.6025 37.9381 38.35 37.7741 38.177 37.5391C38.0041 37.3042 37.9225 37.0143 37.9475 36.7237C37.9695 36.425 38.1062 36.1465 38.3288 35.9463C38.5514 35.746 38.8428 35.6396 39.1421 35.6492C40.6473 35.645 42.1526 35.6457 43.6578 35.6464H43.6596C44.4126 35.6467 45.1656 35.6471 45.9187 35.6468ZM39.1437 48.3777H45.8831C46.4983 48.3777 47.1137 48.378 47.7293 48.3784C49.3713 48.3793 51.0143 48.3802 52.6573 48.3745C52.9718 48.3764 53.2742 48.2532 53.498 48.0322C53.7217 47.8111 53.8485 47.5102 53.8504 47.1956C53.8522 46.8811 53.7291 46.5787 53.508 46.355C53.287 46.1312 52.986 46.0045 52.6715 46.0026C48.1538 45.9999 43.6361 45.9986 39.1184 45.9986C38.9334 45.9939 38.7503 46.036 38.5859 46.121C38.4216 46.206 38.2814 46.3312 38.1783 46.4849C37.9071 46.8683 37.8597 47.285 38.0716 47.7119C38.1625 47.9179 38.3135 48.0916 38.5048 48.2104C38.6961 48.3292 38.9188 48.3875 39.1437 48.3777Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1147_1292",
    x: 0,
    y: 0,
    width: 74,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1147_1292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1147_1292",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1147_1292",
    x1: 37,
    y1: 0,
    x2: 37,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0742F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2WizSelected);
export default __webpack_public_path__ + "static/media/step2WizSelected.acbda74c1c1740ec48acaf40abf4b2f6.svg";
export { ForwardRef as ReactComponent };